<div class="reset-password"
     [formGroup]="form">

  <mat-form-field id="username"
                  appearance="outline">
    <mat-label>Username</mat-label>

    <input matInput
           type="text"
           id="txtUserName"
           autocomplete="username"
           formControlName="username"
           name="Username"
           autofocus
           required>

    <mat-error>
      Username is required.
    </mat-error>
  </mat-form-field>

  <mat-form-field id="password"
                  appearance="outline">
    <mat-label>New Password</mat-label>

    <input matInput
           type="password"
           id="txtPassword"
           autocomplete="new-password"
           formControlName="password"
           name="Password"
           required>

    <mat-error>
      Password is required.
    </mat-error>
  </mat-form-field>

  <mat-form-field id="confirmPassword"
                  appearance="outline">
    <mat-label>Confirm New Password</mat-label>

    <input matInput
           type="password"
           id="txtConfirmPassword"
           autocomplete="new-password"
           formControlName="confirmPassword"
           name="ConfirmPassword"
           required>

    <mat-error>
      @if (
        form.controls.confirmPassword.hasError('required') ||
        form.controls.confirmPassword.hasError('passwordMismatch')
      ) {
        Confirm Password is required and must match.
      }
    </mat-error>
  </mat-form-field>

  @if (errorMessage) {
    <div class="ez-alert warn">
      <mat-icon color="warn">report</mat-icon>
      <div class="error-text">
        {{ errorMessage}}
        @if (passwordLinkInvalid) {
          <a href="{{ forgotPasswordUrl }}">Click here to reset your password.</a>
        }
      </div>
    </div>
  }

  <div class="reset-footer">
    <button mat-flat-button
            type="submit"
            color="primary"
            (click)="changePassword($event)">Change password</button>
  </div>
</div>
